import { render, staticRenderFns } from "./CompanyServiceCompaniesListPage.vue?vue&type=template&id=6a259521&scoped=true"
import script from "./CompanyServiceCompaniesListPage.vue?vue&type=script&lang=js"
export * from "./CompanyServiceCompaniesListPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyServiceCompaniesListPage.vue?vue&type=style&index=0&id=6a259521&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a259521",
  null
  
)

export default component.exports